import {  MediaContainer } from "../../containers";
import "./style.scss";
function Media() {
  
  return (
    <div id="mediaPage">
      <MediaContainer />
      
    </div>
  );
}
export default Media;